module.exports = __webpack_public_path__ + "img/greetsiel.264b3732.jpg";